import { c as _c } from "react/compiler-runtime";
import { LOCALE } from '@/constants/config';
import useTranslate from '@/contexts/i18nContext/hooks/useTranslate';
import { capitalize, formatToLocalizedDate } from '@winelidays/wld-tsx-2/utils';
import FiltersSummaryLine from './FiltersSummaryLine';
const getStringDate = ({ date, completion }) => {
    if (!date || completion !== true && !completion.date)
        return '-';
    const values = [];
    if (date.startDate) {
        values.push(formatToLocalizedDate(date.startDate, LOCALE));
    }
    if (date.endDate && date.endDate !== date.startDate) {
        values.push(formatToLocalizedDate(date.endDate, LOCALE));
    }
    return values.join(' - ');
};
const DateContent = (t0) => {
    const $ = _c(9);
    const { date, completion } = t0;
    const translate = useTranslate();
    const t1 = date && date.endDate ? 2 : 1;
    let t2;
    if ($[0] !== t1 || $[1] !== translate) {
        t2 = capitalize(translate("messages.date", { count: t1 }));
        $[0] = t1;
        $[1] = translate;
        $[2] = t2;
    }
    else {
        t2 = $[2];
    }
    const label = t2;
    let t3;
    if ($[3] !== completion || $[4] !== date) {
        t3 = getStringDate({ date, completion });
        $[3] = completion;
        $[4] = date;
        $[5] = t3;
    }
    else {
        t3 = $[5];
    }
    const value = t3;
    if (!date) {
        return null;
    }
    let t4;
    if ($[6] !== label || $[7] !== value) {
        t4 = <FiltersSummaryLine label={label} value={value}/>;
        $[6] = label;
        $[7] = value;
        $[8] = t4;
    }
    else {
        t4 = $[8];
    }
    return t4;
};
export default DateContent;
